import React from 'react';
import { SettingIcon } from '../icons/Icons';
import { MultiSelectWithIconButton } from '../inputfields/MultiSelectWithIconButton';
import { IconWithTooltip } from '../icons/IconWithTooltip';

export function ColumnSelector({ options, allColumns, action, activeColumns }) {
    const onClick = (columns, event) => {
        /* eslint-disable array-callback-return */
        allColumns.map(column => {
            const state = column.getToggleHiddenProps();
            if (typeof column.Header === 'string') {
                if (columns.includes(column) && false === state.checked) {
                    column.toggleHidden();
                }
                if (!columns.includes(column) && true === state.checked) {
                    column.toggleHidden();
                }
            }
        });
        action(columns, event);
    }

    return (
        <div className='filter-selector action-button'>
            <IconWithTooltip title="Oszlopok módosítása" >
                <MultiSelectWithIconButton options={options} initialOptionState={activeColumns} action={onClick} icon={<SettingIcon />} />
            </IconWithTooltip>
        </div>
    )
}